import { Sprite, Texture } from 'pixi.js';
import vars from '../vars';

class MainStage {
  constructor(parent) {
    this.parent = parent;

    this.ref = new Sprite();
    this.sprite = new Sprite(Texture.EMPTY);
    this.ref.addChild(this.sprite);
    this.resize();

    this.ref.sortableChildren = true;

    this.parent.addChild(this.ref);
  }

  resize() {
    this.sprite.width = vars.layout.FRAME_WIDTH;
    this.sprite.height = vars.layout.MAIN_STAGE_HEIGHT;

    this.sprite.position.y = vars.layout.FRAME_TOP_DIFFERENCE;
  }

  destroy() {
    this.ref.destroy({ children: true });
  }
}

export default MainStage;
